import { MasterTransportListResponse } from "services/interface";
import styled from "@emotion/styled";
import { Col, Row, message } from "antd";
import { FC } from "react";
import TableTransportationList from "../TableTransportationList";
import { useDeleteMasterTransport } from "hooks/useMasterData";

interface TransportationListProps {
  data: MasterTransportListResponse | undefined;
  refetch: () => void;
}

const TransportationList: FC<TransportationListProps> = ({ data, refetch }) => {
  const { mutate: DeleteTransportation, isPending: deleteLoading } =
    useDeleteMasterTransport();

  const onDeleteConfigs = (id: string) => {
    DeleteTransportation(
      {
        id: id,
      },
      {
        onSuccess: (res) => {
          if (res.status === "success") {
            message.success("ลบสำเร็จ");
            refetch();
          } else {
            message.error(`ลบไม่สำเร็จ: ${res.error_message}`);
          }
        },
        onError: (error) => {
          message.error(`ลบไม่สำเร็จ: ${error.message}`);
        },
      }
    );
  };

  return (
    <WrapperAll>
      <Row
        gutter={[16, 16]}
        style={{ backgroundColor: "#EFEFEF", overflow: "auto" }}
      >
        <Col span={24}>
          <CardWrapperTable>
            <TableTransportationList
              data={data?.data.master_data}
              onDeleteConfigs={onDeleteConfigs}
            />
          </CardWrapperTable>
        </Col>
      </Row>
    </WrapperAll>
  );
};

export default TransportationList;
const WrapperAll = styled.div`
  padding: 16px 0px 10px 0px;
  background-color: #efefef;
`;

const CardWrapperTable = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: auto;
  background-color: #ffffff;
  padding: 5px;
`;
